const UserMenuStyle = (theme) => {
  const { defaultFont, palette, header } = theme;

  return {
    buttonProfile: {
      margin: "5px",
      alignItems: "flex-start",
    },
    dealerStyle: {
      fontFamily: defaultFont.fontFamily,
      fontSize: "11px",
    },
    buttonStyle: {
      ...header.button,
    },
    itemLink: {
      display: "flex",
      alignItems: "center",
      color: palette.topBar.activeBkColor,
      fontFamily: defaultFont.fontFamily,
      fontSize: defaultFont.fontSize,
      "&:hover": {
        color: palette.topBar.activeBkColor,
      },
    },
    gridContainer: {
      margin: "5px",
      "& div": {
        flexWrap: "inherit",
        alignItems: "center",
        "& div": {
          borderTop: "none",
          "& p": {
            color: "white",
            fontFamily: defaultFont.fontFamily,
            fontSize: defaultFont.fontSize,
            flexWrap: "inherit",
            borderTop: "none",
          },
        },
      },
    },
    gridItem: {
      paddingBottom: "23px !important",
      "& div": {
        backgroundColor: palette.topBar.activeBkColor,
      },
    },
  };
};

export default UserMenuStyle;
